import { useLazyQuery } from '@apollo/client';
import { TaxonomyNodeSuggestionOption } from '@modules/common/components/TaxonomyNodesAutoComplete/types';
import { FETCH_TAXONOMY_SEARCH_GROUPS_GQL } from '@modules/common/hooks/useFetchTaxonomySearchGroups/constants';
import { getTaxonomySearchGroupOptions } from '@modules/common/hooks/useFetchTaxonomySearchGroups/helpers/getTaxonomySearchGroupOptions';
import { ListTaxonomySearchGroupsInput, Query } from 'generated/graphql';
import { useCallback, useRef, useState } from 'react';
import { useGetUser } from 'v2/core/services/user';

export function useFetchTaxonomySearchGroups() {
  const {
    tenant: { id: tenantID },
  } = useGetUser();
  const [rows, setRows] = useState<string[][]>([]);
  const [options, setOptions] = useState<TaxonomyNodeSuggestionOption[]>([]);

  const [fetchTaxonomySearchGroups, resp] = useLazyQuery<
    Query,
    ListTaxonomySearchGroupsInput
  >(FETCH_TAXONOMY_SEARCH_GROUPS_GQL, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    onCompleted(data) {
      const { options, rows } = getTaxonomySearchGroupOptions({
        taxonomySearchGroups: data.listTaxonomySearchGroups?.groups,
      });

      setOptions(options);
      setRows(rows);
    },
  });

  const deps = {
    tenantID,
    fetchTaxonomySearchGroups,
  };
  const depsRef = useRef(deps);
  depsRef.current = { ...deps };

  const fetchTaxonomySearchGroupOptions = useCallback((searchTerm?: string) => {
    depsRef.current.fetchTaxonomySearchGroups({
      variables: {
        tenantID: depsRef.current.tenantID,
        limitOptions: 3,
        searchTerm,
      },
    });
  }, []);

  return [
    fetchTaxonomySearchGroupOptions,
    {
      rows,
      options,
      isLoading: resp.loading,
    },
  ] as const;
}
